import React from "react";
import { DragDropContext, Droppable,  } from "react-beautiful-dnd";
import "./Plans.scss";
import PlanNoSearch from "../Plan/PlanNoSearch";

export default function PlansNoSearch({plan, isAdmin, removeExercise, removeSet, onDragEnd, addFood, onChange, error}) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sets" type="parent">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {plan.map((item, idx) => (
              <PlanNoSearch set={item} isAdmin={isAdmin} set_idx={idx} error={error} addFood={addFood} onChange={onChange} removeSet={(e) => removeSet(e)} removeExercise={removeExercise}/>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
